import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined'
import TableViewOutlinedIcon from '@mui/icons-material/TableViewOutlined'
import { POLICY_IMPORT_EXCEL_PATH, POLICY_IMPORT_PATH, POLICY_IMPORT_PDF_PATH } from '../common/policy-import-common'

export interface ImportOption {
    id: string
    to: string
    title: string
    description: string
    hint: string
    Icon: typeof PictureAsPdfOutlinedIcon
    tone: string
}

export const IMPORT_OPTIONS: ImportOption[] = [
    {
        id: 'pdf',
        to: POLICY_IMPORT_PDF_PATH,
        title: 'Importar carátulas (PDF)',
        description: 'Suelta las carátulas originales de tus pólizas y las leemos por ti.',
        hint: 'Varios archivos a la vez',
        Icon: PictureAsPdfOutlinedIcon,
        tone: 'bg-tone-pink text-tone-pink-ink',
    },
    {
        id: 'excel',
        to: POLICY_IMPORT_EXCEL_PATH,
        title: 'Importar desde Excel',
        description: 'Llena el formato de importación y valida la información antes de importar.',
        hint: 'Formato .xlsx',
        Icon: TableViewOutlinedIcon,
        tone: 'bg-tone-teal text-tone-teal-ink',
    },
]

export const usePolicyImportMenuModel = () => ({
    options: IMPORT_OPTIONS,
    linkState: { backUrl: POLICY_IMPORT_PATH },
})
